export const ScriptPublishStatusMessages = [
  'Публикация не запрашивалась',
  'Указанный экземпляр успешно опубликован',
  'Указанный экземпляр не найден в скрипте',
  'Указанный экземпляр не версионирован',
  'Указанный экземпляр уже является опубликованным',
]

export enum ScriptStatus {
  Unpublish = 0,
  Publish,
}

export enum ScriptAction {
  Clone = 'clone',
  Publish = 'publish',
  UnPublish = 'unpublish',
  SaveEdits = 'saveEdits',
  PublishEdits = 'publishEdits',
  DeleteItem = 'deleteItem',
  Draft = 'draft',
  RemoveDraft = 'removeDraft',
}

export enum ScriptPublishStatus {
  Not = 0,
  Success,
  NotFound,
  NotVersioned,
  WasPublished,
}

export enum CardVariant {
  A = 'a',
  B = 'b',
}

export enum CardBlockType {
  Text = 1,
  Input = 2,
  Comment = 3,
  Title = 4,
  Answer = 5,
  Border = 6,
  Collapse = 7,
}

export enum CardOptionType {
  Final = 0,
  Card = 1,
  Script = 2,
}

export enum CardOptionTypeCreate {
  Final = 0,
  Card = 1,
  Script = 2,
  NewCard = 3,
}

export enum HistoryItemType {
  CardRequestedData = 1,
  OptionChoosedData = 2,
  ScriptFinishedData = 3,
  ReturnedToCardData = 4,
}

export enum ScriptMode {
  Edit = 'Edit',
  Active = 'Active',
  Preview = 'Preview',
}

export const MAX_OPTIONS_COUNT = 9
